export const getPagination = ({ pagination }) => pagination;
export const categoria_empty = () => ({
  nome: "",
  descricao: "",
});
